module.exports = __webpack_public_path__ + "img/ZTOBUHaveOrder_06.9a348f6d.jpg";